import { fileSrc } from "@/lib/api";
import { kindIcon } from "@/components/StatusBadge";
import { Download } from "lucide-react";

export function FilePreview({ file }) {
  const { id, kind, content_type, extracted_text } = file;
  const src = fileSrc(id);

  if (kind === "image") {
    return (
      <div className="rounded-xl overflow-hidden border border-white/10 bg-[#070B14] flex items-center justify-center">
        <img data-testid="file-preview-image" src={src} alt={file.title} className="max-h-[520px] w-auto object-contain" />
      </div>
    );
  }
  if (kind === "pdf") {
    return <iframe data-testid="file-preview-pdf" title="preview" src={src} className="w-full h-[600px] rounded-xl border border-white/10 bg-white" />;
  }
  if (kind === "video") {
    return <video data-testid="file-preview-video" src={src} controls className="w-full rounded-xl border border-white/10 max-h-[520px] bg-black" />;
  }
  if (kind === "audio") {
    return (
      <div className="rounded-xl border border-white/10 bg-[#111827] p-8">
        <audio data-testid="file-preview-audio" src={src} controls className="w-full" />
      </div>
    );
  }
  if ((kind === "text" || content_type?.startsWith("text/")) && extracted_text) {
    return (
      <pre data-testid="file-preview-text" className="rounded-xl border border-white/10 bg-[#070B14] p-5 text-sm text-slate-300 whitespace-pre-wrap max-h-[520px] overflow-auto font-mono leading-relaxed">
        {extracted_text}
      </pre>
    );
  }
  return (
    <div className="rounded-xl border border-white/10 bg-[#111827] p-10 flex flex-col items-center justify-center gap-4 text-center">
      <div className="text-blue-400">{kindIcon(kind, "w-12 h-12")}</div>
      <p className="text-slate-400 text-sm">In-browser preview isn't available for this format. The original file is preserved.</p>
      {extracted_text && (
        <pre className="w-full text-left rounded-lg bg-[#070B14] p-4 text-xs text-slate-400 whitespace-pre-wrap max-h-64 overflow-auto font-mono">{extracted_text.slice(0, 3000)}</pre>
      )}
      <a href={fileSrc(id, true)} className="inline-flex items-center gap-2 text-sm text-blue-400 hover:text-blue-300" data-testid="preview-download-link">
        <Download className="w-4 h-4" /> Download original
      </a>
    </div>
  );
}
